import { createFileRoute } from "@tanstack/react-router";
import { MyIssuesPage } from "@/components/issues/my-issues-page";

export const Route = createFileRoute("/_app/$workspaceSlug/my-issues")({
  component: MyIssuesRoute,
});

function MyIssuesRoute() {
  const { workspaceSlug } = Route.useParams();
  // Keyed by workspace: the selection and the place in the list are one workspace's.
  return <MyIssuesPage key={workspaceSlug} />;
}
